function onDomReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

function onWindowLoad(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

function initCollectionDescriptionToggle() {
  var $description = $('#collection-description');
  var $toggle = $('#read-more-toggle');

  if (!$description.length || !$toggle.length) return;

  var moretext = $description.attr('data-read-more');
  var lesstext = $description.attr('data-read-less');
  var productDescription = $description.height();
  var textHeight = $(window).width() < 768 ? 27 : 74;

  if (productDescription < textHeight) {
    $toggle.hide();
    return;
  }

  $toggle.off('click.collectionDescription').on('click.collectionDescription', function () {
    var elem = $toggle.html();

    if (elem == moretext) {
      $toggle.text(lesstext);
      $description.addClass('active');
    } else {
      $toggle.text(moretext);
      $description.removeClass('active');
    }
  });
}

function moveCollectionDescriptionDesktop() {
  if ($(window).width() <= 768) return;

  var $wrapper = $('.collection-desc-wrapper');
  var $nav = $('.collection-nav');

  if (!$wrapper.length || !$nav.length) return;

  $wrapper.insertBefore($nav);
  $wrapper.css('opacity', '1').css('height', 'auto');
}

function initCollectionBlockSliders(scope = document) {
  var root = scope && scope.nodeType === 1 ? scope : document;
  var sliders = [];

  if (root.matches && root.matches('[data-products-slider]')) {
    sliders = [root];
  } else {
    sliders = Array.prototype.slice.call(root.querySelectorAll('[data-products-slider]'));
  }

  sliders.forEach(function (slider) {
    if (slider.dataset.sliderInitialized === 'true') return;

    var track = slider.querySelector('[data-slider-track]');
    var prevButton = slider.querySelector('[data-slider-prev]');
    var nextButton = slider.querySelector('[data-slider-next]');

    if (!track || !prevButton || !nextButton) return;

    function getScrollAmount() {
      var firstProduct = track.querySelector('.block-product');
      if (!firstProduct) return 0;

      var productStyles = window.getComputedStyle(firstProduct);
      var marginRight = parseFloat(productStyles.marginRight) || 0;
      var marginLeft = parseFloat(productStyles.marginLeft) || 0;

      return firstProduct.offsetWidth + marginLeft + marginRight;
    }

    function updateButtons() {
      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      var scrollLeft = track.scrollLeft;

      prevButton.classList.toggle('show', scrollLeft > 5);
      nextButton.classList.toggle('show', scrollLeft < maxScrollLeft - 5);
    }

    prevButton.addEventListener('click', function () {
      var scrollAmount = getScrollAmount();
      track.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
      window.setTimeout(updateButtons, 300);
    });

    nextButton.addEventListener('click', function () {
      var scrollAmount = getScrollAmount();
      track.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
      window.setTimeout(updateButtons, 300);
    });

    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    slider.dataset.sliderInitialized = 'true';
    updateButtons();
  });
}

window.initCollectionBlockSliders = initCollectionBlockSliders;

function initCollectionScrollMemory() {
  document.body.addEventListener('click', function (event) {
    var target = event.target.closest('[data-scroll-id]');
    if (!target) return;

    var scrollId = target.getAttribute('data-scroll-id');
    localStorage.setItem('lastClickedScrollId', scrollId);
  });
}

function restoreCollectionScrollPosition() {
  var scrollId = localStorage.getItem('lastClickedScrollId');
  if (!scrollId) return;

  var target = document.querySelector('[data-scroll-id="' + scrollId + '"]');
  if (!target) return;

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  localStorage.removeItem('lastClickedScrollId');
}

onDomReady(function () {
  initCollectionDescriptionToggle();
  moveCollectionDescriptionDesktop();
  initCollectionBlockSliders(document);
  initCollectionScrollMemory();
});

onWindowLoad(function () {
  restoreCollectionScrollPosition();
});